import jota from "@/assets/team/jota.png"
import robson from "@/assets/team/robson.jpg"

import email from "@/assets/icons/email.png"
import linkedin from "@/assets/icons/linkedin.png"
import github from "@/assets/icons/github.png"
import portfolio from "@/assets/icons/portfolio.png"
import itch from "@/assets/icons/itchio.png"

const teamImages = {
  jota,
  robson
}

const icons = {
  email,
  linkedin,
  github,
  portfolio,
  itch,
}

export const titles = {
  pt: {
    first: "Nossa",
    second: "Equipe",
    description:
      "Conheça o time por trás da Black Paladins"
  },
  en: {
    first: "Our",
    second: "Team",
    description:
       "Meet the team behind Black Paladins"
  }
}

export const equipe = [
  {
    nome: "Jérffeson Araújo",

    avatarStyle: "avatar-1",

    foto: teamImages.jota,

    skills: [
      "C#",
      "Unity",
      "XR",
      "VR",
      "Unreal Engine",
      "Construct 2"
    ],

    pt: {
      cargo:
        "Unity Programmer • Game Developer • VR Developer • Game Designer • Level Designer",

      sobre:
        "Desenvolvedor especializado em C# e Unity. Responsável por toda a lógica e mecânicas dos jogos."
    },

    en: {
      cargo:
        "Unity Programmer • Game Developer • VR Developer • Game Designer • Level Designer",

      sobre:
        "Developer specialized in C# and Unity. Responsible for all game logic and mechanics."
    },

    redes: [
      {
        nome: "LinkedIn",
        icon: icons.linkedin,
        link: "https://www.linkedin.com/in/jerffesonj/"
      },
      {
        nome: "Portfolio",
        icon: icons.portfolio,
        link: "https://jerffesonj.github.io/"
      },
      {
        nome: "Email",
        icon: icons.email,
        link: "mailto:jerffesonj@gmail.com"
      },

      {
        nome: "GitHub",
        icon: icons.github,
        link: "https://github.com/jerffesonj/"
      },
    ]
  },

  {
    nome: "Robson Santos",

    avatarStyle: "avatar-2",

    foto: teamImages.robson,

    skills: [
      "2D Art",
      "3D Art",
      "Blender",
      "Photoshop",
      "Illustrator",
      "UI/UX"
    ],

    pt: {
      cargo:
        "Artista 2D • Modelador 3D • Animador 2D e 3D • Game Designer • Level Designer",

      sobre:
        "Artista responsável por toda a identidade visual, artes e modelagens dos projetos."
    },

    en: {
      cargo:
        "2D Artist • 3D Modeler • 2D and 3D Animator • Game Designer • Level Designer",

      sobre:
        "Artist responsible for all visual identity, art, and 3D modeling of the projects."
    },

    redes: [
      {
        nome: "LinkedIn",
        icon: icons.linkedin,
        link:
          "https://www.linkedin.com/in/robson-dos-santos-29262812a"
      },
      {
        nome: "Portfolio",
        icon: icons.portfolio,
        link: "https://rob-dos-santos.webflow.io/"
      },
      {
        nome: "Email",
        icon: icons.email,
        link: "mailto:rob.animart@gmail.com"
      },
      {
        nome: "itch.io",
        icon: icons.itch,
        link: "https://roobbh.itch.io/"
      },
    ]
  }
]